<template>
    <div class="listing mx-auto">
        <b-container fluid>
            <b-row>
                <b-col md="12">
                    <b-card border-variant="light">
                        <b-form @submit="onSubmit" v-on:keydown.enter.prevent>

                            <b-col xl="10" lg="11" md="12">

                                <b-form-group label="Search By Listing Id" label-cols="3" breakpoint="md" horizontal>
                                    <b-input v-model="listing_id" @keyup="myDebouncedFunc"></b-input>
                                </b-form-group>

                                <b-form-group label="Search By Listing Address" label-cols="3" breakpoint="md" horizontal>
                                    <autocomplete name="address" placeholder="Search by Address"
                                                  v-model="autocomplete.address.item"
                                                  :component-item="autocomplete.address.template"
                                                  :items="autocomplete.address.items"
                                                  :get-label="addressGetlabel"
                                                  :autoSelectOneItem="false"
                                                  :min-len="autocomplete.address.minLength"
                                                  @change="addressInputChanged"
                                                  @item-selected="addressItemSelected"
                                                  @update-items="addressUpdate" required>
                                    </autocomplete>
                                </b-form-group>

                                <b-form-group label="Cooperating Commission Pct" label-cols="3"
                                              breakpoint="md" horizontal v-if="this.listingLocal.CurrentPrice !== null">
                                    <b-input v-model="listingLocal.commission"></b-input>
                                </b-form-group>

                                <b-button type="submit" variant="primary">Update</b-button>
                            </b-col>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>

                <b-row class="mb-1 bg-white" v-if="this.listingLocal.CurrentPrice !== null">
                    <b-col cols="12">
                        <div class="text-center">
                            <h3>{{listingLocal.UnparsedAddress}}</h3>
                        </div>
                        <b-table class="listing-table"
                                 bordered
                                 stacked
                                 border-variant="light"
                                 :items="items">
                        </b-table>
                    </b-col>
            </b-row>
            <!-- Loading element -->
            <div id="loading" class="loading" v-if="isLoading">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </b-container>

    </div>
</template>

<script>
import addressTemplate from './autocomplete/templates/address_template'
import _ from "lodash";

export default {
    name: "Listing",

    created() {
        if(this.$route.params.listingId !== undefined) {
            this.getListing(this.$route.params.listingId);
        }
    },

    data() {
        return {
            listing_id: null,
            isLoading: false,
            listingLocal: {
                ListAgentName: null,
                CurrentPrice: null,
                MlsStatus: null,
                PropertySubType: null,
                BedsTotal: null,
                BathsTotal: null,
                BathsHalf: null,
                MLSAreaMajor: null,
                SubdivisionName: null,
                LivingArea: null,
                YearBuilt: null,
                architectural_style: null,
                daysOnMarket: null,
                commission: null
            },
            autocomplete: {
                address: {
                    item: null,
                    items: [],
                    minLength: 3,
                    selected: false,
                    template: addressTemplate
                },
            },
            listing: {
                ListingKey: null,
                UnparsedAddress: null,
            },
            commission: null,
            breadcrumb_items: []
        }
    },
    methods: {
        myDebouncedFunc: _.debounce(function (event) {
            console.log(event.target.value);
            this.getListing(event.target.value);
        }, 1000),
        getKeyInput(event) {
            console.log(event.target.value);
            this.getListing(event.target.value);
        },
        //support autocomplete for customer email
        addressGetlabel(item) {
            return item ? item.UnparsedAddress : '';
        },
        addressInputChanged(text) {
            this.listing.UnparsedAddress = text;
        },
        async addressItemSelected(item) {
            if (item) {
                this.listing.ListingKey = item.ListingKey;
                // this.getListingDetails();
                await this.getListing(item.ListingKey);
            }
        },
        addressUpdate(text) {
            let _self = this;
            if (text.length > 3) {
                let _self = this;
                _self.isLoading = true;
                axios.get('/api/search/address', {params: {keywords: text}})
                    .then(function (response) {
                        _self.isLoading = false;
                        _self.autocomplete.address.items = $.map(response.data, function (dataItem) {
                            dataItem = dataItem.StandardFields;
                            return {
                                ListingKey: dataItem.ListingKey,
                                UnparsedAddress: dataItem.UnparsedAddress,
                                MlsStatus: dataItem.MlsStatus
                            };
                        });
                    });
            }
        },
        getListing(listingKey) {
            let _self = this;
            _self.isLoading = true;

            let route = '/api/listing/' + listingKey;

            let promise = axios.get(route);

             return promise.then((response) => {
                _self.isLoading = false;

                if (typeof response.data !== 'undefined') {
                    _self.listingLocal = response.data.listing;
                }
            }).catch(
                (error) => {
                    _self.isLoading = false;
                    console.log(error);
                }
             );
        },
        onSubmit(e) {
            e.preventDefault();
            let _self = this;
            let listing_id = this.listingLocal.ListingKey;
            _self.isLoading = true;
            let data = {
                commission: _self.listingLocal.commission
            };
            axios.post('/api/listings/edit/' + listing_id, data)
                .then(function (response) {
                    _self.isLoading = false;
                    console.log(response);
                    Toast.fire({
                        icon: 'success',
                        title: "Listing updated successfully!"
                    });
                    this.$Progress.finish();

                    window.location.href = '/admin/listings/' + listing_id;

                }).catch(function (error) {
                    console.log(error);
                    _self.isLoading = false;
                }
            )
        },
        formatCurrency(variable) {
            return '$' + new Intl.NumberFormat().format(variable);
        },
        formatNA(variable) {
            if (variable === '********') {
                return "N/A"
            }
            return variable;
        },
    },
    computed: {
        items() {
            if (this.listingLocal !== null) {
                return [
                    {
                        'Agent': this.listingLocal.ListAgentName,
                        'List Price': this.formatCurrency(this.listingLocal.CurrentPrice),
                        'Status': this.listingLocal.MlsStatus,
                        'Property Type': this.listingLocal.PropertySubType,
                        'Beds': this.formatNA(this.listingLocal.BedsTotal),
                        'Bathrooms Total': this.formatNA(this.listingLocal.BathsTotal),
                        'Bathrooms Half': this.formatNA(this.listingLocal.BathsHalf),
                        'Neighborhood': this.listingLocal.MLSAreaMajor,
                        'Subdivision Name': this.listingLocal.SubdivisionName,
                        'Living Area': this.formatNA(this.listingLocal.LivingArea),
                        'Year Built': this.formatNA(this.listingLocal.YearBuilt),
                        'Architectural Style': this.architectural_style,
                        'Days on Market': this.listingLocal.daysOnMarket,
                        'Co-op': this.listingLocal.commission + '%',
                    }
                ];
            }
        }
    },
}
</script>

<style scoped>

</style>
